/**
 * Die Anschrift als eine Zeile — für die Treffer der Auswahlsuche (HJ-042).
 *
 * Mehrere Kunden und Orte heißen gleich und sitzen woanders. Auseinanderzuhalten
 * sind sie nur an der Anschrift, und ein Standort hat oft dieselbe PLZ wie sein
 * Nachbar — deshalb gehört hier, anders als in der Kopfzeile einer Tour, auch die
 * Straße dazu.
 *
 * Eigene Datei ohne Supabase, damit `npm run logik` sie prüfen kann.
 */

type Teil = string | null | undefined;

/** „Hauptstraße 12, 72458 Albstadt" — oder `null`, wenn nichts bekannt ist. */
export function anschriftszeile(strasse: Teil, plz: Teil, ort: Teil): string | null {
  const stadt = [plz, ort].map((t) => t?.trim()).filter(Boolean).join(' ');
  return [strasse?.trim(), stadt].filter(Boolean).join(', ') || null;
}
